export default function ($el) {
  let fullMissionHeight = 0;
  const missionCollapsedHeight = $el.data('min-height') || 180;
  let missionStatementCharacterCount = 0;
  const maxMissionStatementCharacterCount = $el.data('max-char') || 675;
  let missionStateExpanded = false;
  const toggleMoreText = 'Read More';
  const toggleLessText = 'Read Less';

  const $missionStatement = $el.find('.mission-statement');
  const $toggleMissionLink = $el.find('.toggle-desktop-mission');

  // Sets up event listeners for click if the mission statement is available for toggling height
  const setupToggleEventListener = function () {
    $toggleMissionLink.on('click', () => {
      if (!missionStateExpanded) {
        // To expand the mission statement when the read more  link is triggered
        // The height of the mission statement is set by the height of the `p` tags with in $missionStatement
        $missionStatement.removeClass('collapsed');
        $missionStatement.addClass('expanded');
        $missionStatement.css('max-height', fullMissionHeight);
        $toggleMissionLink.html(toggleLessText);
        missionStateExpanded = true;
      } else {
        // To contract the mission statement when the read less link is triggered
        // Return the height to the initial value set from `missionCollapsedHeight`
        $missionStatement.removeClass('expanded');
        $missionStatement.addClass('collapsed');
        $missionStatement.css('max-height', `${missionCollapsedHeight}px`);
        $toggleMissionLink.html(toggleMoreText);
        missionStateExpanded = false;
      }
    });
  };

  const enableOrDisableMissionStatementToggleBasedOnCharacterCount =
    function () {
      // reset the counter variables so they don't keep incrementing as they're called
      fullMissionHeight = initialFullMissionHeight();
      missionStatementCharacterCount = 0;

      $missionStatement.find('p').each(function () {
        fullMissionHeight += $(this).outerHeight(true);
        missionStatementCharacterCount += $(this).text().length;
      });

      if (missionStatementCharacterCount > maxMissionStatementCharacterCount) {
        $missionStatement.addClass('mission-truncated');
      }
    };

  const initialFullMissionHeight = function () {
    // add a 500px buffer because calculating outerHeight is impercise at page load time
    return fullMissionHeight === 0 ? 500 : 0;
  };

  setupToggleEventListener();
  enableOrDisableMissionStatementToggleBasedOnCharacterCount();
  setTimeout(enableOrDisableMissionStatementToggleBasedOnCharacterCount, 2000);

  $(window).on('resize orientationchange', () => {
    enableOrDisableMissionStatementToggleBasedOnCharacterCount();
  });
}
